import { useMemo } from 'react';
import { SourceType } from 'src/modules/generated/api';
import { sources as sourceOptions } from 'src/modules/labels';
import { Option } from 'src/types';

import { useUser } from './useUser';

export const INACTIVE_SOURCES: SourceType[] = [
  SourceType.AudiGws,
  SourceType.Autobid,
  SourceType.Autorola,
  SourceType.Auto1,
  SourceType.Okcars,
  SourceType.Arval,
  SourceType.Ucs,
  SourceType.VwnGws,
];

export const getSourceOptions = (
  sources: SourceType[],
  visibleInactiveSources: SourceType[] = [],
): Option<SourceType>[] =>
  sourceOptions
    .filter((option) => sources.includes(option.value))
    .filter((o) => !INACTIVE_SOURCES.includes(o.value) || visibleInactiveSources.includes(o.value));

export const useSources = () => {
  const { data: user, ...query } = useUser();
  const data = useMemo(
    () =>
      user &&
      sourceOptions.filter((option) => user?.allowedSources?.includes(option.value)).map((option) => option.value),
    [user],
  );

  return {
    data,
    ...query,
  };
};
